<template>
    <el-link  class="x-link" :href="config.href" :disabled = "config.disabled" :underline="config.underline" :modelValue="modelValue" @update:modelValue="(value) => $emit('update:modelValue', value)" :target="config.target || '_blank'" @click="$emit('click', modelValue)">
        <el-icon v-if="modelValue != null && modelValue != ''"><Link/></el-icon>{{label}}</el-link>
</template>
<script setup>
import { defineProps, ref, watch } from 'vue';
import { Link } from '@element-plus/icons-vue';
import DataOptions from '../../dataview/DataOptions';
import { getDynamicOptions, getOptions } from '../utils.js';

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null }
})
const dataOptions = ref(null);

const label = ref(props.config?.value);
const getContent = async (modelValue, config)=> {
    if (config?.value) {
        label.value = config.value;
        return;
    }
    let keys = modelValue;
    if (!keys) {
        label.value = null;
        return;
    } 
    if (!config?.dataOptions) {
        label.value = modelValue;
        return;
    }
    if (!(keys instanceof Array)) keys = [keys];
    const datas = await config?.dataOptions.dataInfo.getByKeysLocal(keys, config?.dataOptions.keyField);
    const options = getDynamicOptions(config?.dataOptions, config.filter, props.data, datas);
    if (!dataOptions.value) dataOptions.value = config?.dataOptions ? new DataOptions(options) : null;
    else dataOptions.value.setOptions(options);
    const value = dataOptions.value ? dataOptions.value.getOptionLabel(modelValue, config?.lastLevel) : modelValue;
    label.value = value != null ? value : config.value;
}
watch(()=>props.modelValue, (value)=> {
    getContent(value, props.config);
}, {immediate:true})

watch(()=>props.config?.dataOptions, (value)=> {
    if (!props.modelValue) return;
    getContent(props.modelValue, props.config);
}, {immediate:true})
defineEmits({
    'update:modelValue': null,
    'click': null
});
</script>
<style scoped>
    .x-link{
        margin: 0 4px;
        display: inline-block;
    }
</style>